import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type UploadAnalyticsCommonParams } from './uploadAnalyticsTypes';
import META from './useTrackUploadPartAborted.meta';

export type UseTrackUploadPartAbortedParams = UploadAnalyticsCommonParams & {
  part_number: number;
  part_size_bytes?: number;
  retry_count?: number;
  max_retry_count?: number;
  abort_reason: 'cancel' | 'pause' | 'transfer_aborted';
  error_message: string;
  error_name?: string;
  error_status_code?: number;
};

export const useTrackUploadPartAborted = () => {
  const { track } = useAnalyticsUtilities();

  const trackUploadPartAborted = useCallback(
    (params: UseTrackUploadPartAbortedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackUploadPartAborted };
};
